/*
  LEFT TO DO:
    A11Y
    - add aria- attributes to the dropdowns
    - add key listeners (if you have time)
*/

((Collection, $) => {
  "use strict";

  const dom = {}; // vanilla 
  const currentParams = {
    "sort_by": ""
  };

  let totalFilterCount = 0;
  let mixer;
  let isInitialLoad = false;

  const DESKTOP_BREAKPOINT = 1024;
  const SORT_VALUES = {
   "manual": "Featured",
   "best-selling": "Best Sellers (default)",
   "price-ascending": "Price: Low to High",
   "price-descending": "Price: High to Low",
   "title-ascending": "Alphabetical: A - Z",
   "title-descending": "Alphabetical: Z - A",
   "created-ascending": "Date: Old to New",
   "created-descending": "Date: New to Old"
  }

  // code to account for iOS nav bar elements
  // https://medium.com/turo-engineering/react-stick-to-bottom-accessible-safari-fixed-bottom-elements-9ed761fbeecb
  const SAFARI_MOBILE_BOTTOM_MENU_HEIGHT = 44;
  let throttleTimer;
  const throttle = (func, delay) => {
    if(throttleTimer) {
      return;
    }

    throttleTimer = setTimeout(() => {
      func();
      throttleTimer = undefined;
    }, delay);
  };

  const cacheDom = () => {
    dom.filterWrapper     = document.querySelector('[data-collection-filters]');
    dom.filterForm        = document.querySelector('[data-filter-form]');
    dom.collectionGrid    = document.querySelector('[data-collection-grid]');
    dom.noMatchMessage    = document.querySelector('[data-no-match]');
    dom.mobileActiveBar   = document.querySelector('[data-mobile-active-filters-wrapper]');
    
    dom.filterBars        = document.querySelectorAll('[data-active-filters]');
    dom.filterGroups      = document.querySelectorAll('[data-filters]')
    dom.filterTitles      = document.querySelectorAll('[data-filter-title]');
    dom.filterOptions     = document.querySelectorAll('[data-filter-group]');
    dom.sortToggles       = document.querySelectorAll('[data-open-sorting]');
    dom.sortOptions       = document.querySelectorAll('[data-sort-options]');
    
    dom.totalFilterCounts = document.querySelectorAll('[data-total-filter-count]')
    dom.filterTypes       = Array.from(document.querySelectorAll('[data-filter-group]')).map(el => el.getAttribute('data-filter-group')).filter(Boolean);
    dom.clearFilters      = document.querySelectorAll('[clear-filters]');
    dom.swatchInputs      = document.querySelectorAll('[data-swatch-input]');
    dom.swatchLabels      = document.querySelectorAll('[data-swatch-label]');
    dom.filterInputs      = document.querySelectorAll('[data-filter-input]');
    dom.filterLabels      = document.querySelectorAll('[data-filter-label]');
    dom.filterCheckboxes  = document.querySelectorAll('[data-filter-checkbox]');
  
  }

  const configMixer = {
    multifilter: {
      enable: true
    },
    controls: {
      toggleLogic: 'and'
    },
    animation: {
      enable: false
    },
    selectors: {
      target: '.collection-product-grid__item-wrapper'
    },
    callbacks: {
      onMixStart: function(state, futureState) {
        showClearButtons();
        if (!isInitialLoad) {
          scrollToFilterTop();
        }
        // dom.mobileFilterControls.addClass('filters-active');
      },
      onMixEnd: function (state) {
        // no items found displays on 'fail state'
        state.hasFailed ? dom.noMatchMessage.style.display = 'flex' : dom.noMatchMessage.style.display = 'none';
        // update filter counts
        updateFilterCounts();
        renderActiveFilters();
        updateFilterParams();
        isInitialLoad = false;
        // mobile -- move collection grid down to make room for active filters (fixed)
        if(window.innerWidth < DESKTOP_BREAKPOINT) {
          adjustProductGridForActiveMobileFilters();
        }

        // hide clear button if the last operation unchecked all filters
        if(document.querySelectorAll('[data-filter-form] input:checked').length === 0) {
          hideClearButtons();
        }

        // unstyle mobile control buttons if filters all inactive
        if(document.querySelectorAll('[class*="__label"].active').length == 0 && document.querySelectorAll('[class*="__label"].selected').length == 0) {
          // dom.mobileFilterControls.removeClass('filters-active');
        }
      },
      onMixClick: function(state, originalEvent) {
        // hide desktop clear button again (until next filters are added)
        hideClearButtons();
      }
    }
  };

  /**
   * When bottom > window.innerHeight, we know that `element` is
   * outside the window bounds. Normally, `position: fixed` keeps the element
   * inside the window bounds.
   */
  const adjustBottomPositionForSafari = (element, offsetBottom) => {
    const {bottom} = element.getBoundingClientRect();
    element.style.bottom = (Math.floor(bottom) > window.innerHeight) 
      ? offsetBottom + SAFARI_MOBILE_BOTTOM_MENU_HEIGHT 
      : offsetBottom;
  };

  const adjustMobileSafariElements = () => {
    if(window.innerWidth < DESKTOP_BREAKPOINT) {
      const mobileFilterOverlay = dom.filterWrapper;
      adjustBottomPositionForSafari(mobileFilterOverlay, 0);
    }
      return;
  }

  const openMobileFilters = () => {
    if(window.innerWidth < DESKTOP_BREAKPOINT) {
      // expand menus (not working)
      const titles = Array.from(dom.filterTitles);
      const groups = Array.from(dom.filterOptions);
      titles.forEach(title => title.classList.add('active'));
      groups.forEach(group => group.classList.add('active'));

      // open filters
      toggleClass(dom.filterWrapper, 'active');

      // prevent scrolling behind the filter menu
      document.body.classList.add('scroll-lock');
    }
  }

  const closeMobileFilters = () => {
    if(window.innerWidth < DESKTOP_BREAKPOINT) {
      toggleClass(dom.filterWrapper, 'active');
    }

    // re-enable scrolling
    document.body.classList.remove('scroll-lock');
  }

  const showClearButtons = () => {
    const buttons = Array.from(dom.clearFilters);
    buttons.forEach(btn => {
      btn.classList.add('is-visible');
    })
  }

  const hideClearButtons = () => {
    const buttons = Array.from(dom.clearFilters);
    buttons.forEach(btn => {
      btn.classList.remove('is-visible');
    })
  }

  const clearFilters = () => {
    const swatchLabels = Array.from(dom.swatchLabels);
    const filterLabels = Array.from(dom.filterLabels);

    hideClearButtons();
    swatchLabels.forEach(label => label.classList.remove('active'));
    filterLabels.forEach(label => label.classList.remove('selected'));
    dom.filterForm.reset();
    updateFilterParams();
  }
 
  const toggleClass = (element, className) => {
    if (element.classList.contains(className)) {
      element.classList.remove(className)
    } else {
      element.classList.add(className)
    }
  }

  const closeAllDropdowns = () => {
    const allFilterMenus = Array.from(dom.filterOptions);
    const allSortDropdowns = Array.from(dom.sortOptions);
    const allSortToggles = Array.from(dom.sortToggles);
    const allSortMenus = allSortDropdowns.concat(allSortToggles);

    allFilterMenus.forEach(menu =>  {
      menu.parentElement.firstElementChild.classList.remove('active'); // title
      menu.classList.remove('active');
    });

    allSortMenus.forEach(item => {
      item.classList.remove('active');
    })
  }

  const updateFilterCounts = () => {
    const filterGroups = Array.from(dom.filterGroups);
    let totalCount = 0;

    filterGroups.forEach(group => {
      let localCount = 0;

      const checkedInputs = Array.from(group.querySelectorAll('input:checked'));
      localCount += checkedInputs.length;
      totalCount += checkedInputs.length;

      const countSpan = group.querySelector('[data-filter-title] span');
      countSpan.textContent = localCount > 0 ? `(${localCount})` : ''
      
    });

    // update totalCount
    const totalCountSpans = Array.from(dom.totalFilterCounts);
    totalCountSpans.forEach(span => span.textContent = totalCount > 0 ? `(${totalCount})` : '');
    totalFilterCount = totalCount; // used only to adjust margin of mobile collection grid
    
  }

  const renderActiveFilters = () => {
    const activeInputs = Array.from(document.querySelectorAll('[data-filter-form] input:checked'));
    const activeLabels = activeInputs.map(input => input.getAttribute('data-label'))
    const filterBars = Array.from(dom.filterBars);
    if (dom.mobileActiveBar) {
      if (activeInputs.length === 0) {
        filterBars.forEach((bar) => (bar.innerHTML = '')); // clear out filters
        dom.mobileActiveBar.style.display = 'none'; // hide mobile filter bar
      } else {
        dom.mobileActiveBar.style.display = 'flex'; // show mobile filter bar
      }
    }
    // get current filters
    const activeButtons = Array.from(document.querySelectorAll('[data-active-filters] button'));
    const currentFilters = new Set(activeButtons.map(button => button.getAttribute('data-filter-value')));

    // get new filters + add them
    const newFilters = activeLabels.filter(label => !currentFilters.has(label));
    newFilters.forEach(label => addFilterButton(label));

    // get stale filters + remove them
    const staleFilters = [...currentFilters].filter(filter => !activeLabels.includes(filter));
    staleFilters.forEach(filter => removeFilterButton(filter));
  }

  const addFilterButton = (value) => {
    const filterBars = Array.from(dom.filterBars);

    filterBars.forEach(bar =>  {
      const button = document.createElement('button');
      const span = document.createElement('span');
      span.textContent = value;
      button.appendChild(span);
      button.setAttribute('data-filter-value', value);
      button.addEventListener('click', handleFilterButtonClick);
      bar.appendChild(button);
    });
  }

  const removeFilterButton = value => {
    const filterBars = Array.from(dom.filterBars);
    filterBars.forEach(bar => {
      const buttons = Array.from(bar.querySelectorAll('button[data-filter-value]'));
      buttons.forEach(button => {
        if(button.getAttribute('data-filter-value') === value) {
          button.remove();
        }
      })
    });
  }

  const handleFilterButtonClick = event => {
    const target = (event.target.matches('span')) ? event.target.parentElement : event.target;
    const filterName = target.getAttribute('data-filter-value');
    removeFilter(filterName); // remove filter
    target.remove(); // remove button
  }

  const removeFilter = filterName => {
    const activeInputs = Array.from(document.querySelectorAll('[data-filter-form] input:checked'));
    const filterInput = activeInputs.find(input => input.getAttribute('data-label') === filterName);
    filterInput.checked = false; // remove filter
    filterInput.dispatchEvent(new Event('change', { 'bubbles': true })); // trigger change event (for mixitup)
    updateFilterCounts();
  }

  const setStickyFilters = () => {
    const promoBar        = document.getElementById('shopify-section-promos');
    const promoPosition   = getComputedStyle(promoBar).position;
    const siteHeader      = document.getElementById('shopify-section-header');
    const stickyFilters   = (window.innerWidth < DESKTOP_BREAKPOINT) 
      ? document.querySelector('[data-sticky-filter-mobile]') 
      : document.querySelector('[data-sticky-filter-desktop]');

    const promoBarOffset     = (promoPosition === 'sticky' || promoPosition === 'fixed')
      ? promoBar.offsetHeight
      : 0;
      
    if(stickyFilters) {
      stickyFilters.style.top = `${promoBarOffset + siteHeader.offsetHeight}px`;
    }
  }

  const scrollToFilterTop = () => {
    const promoBar        = document.getElementById('shopify-section-promos');
    const siteHeader      = document.getElementById('shopify-section-header');
    const filterTop       = promoBar.offsetHeight + siteHeader.offsetHeight;

    if(window.scrollY > filterTop) {
      window.scrollTo(0, filterTop);
    }
  }

  const adjustProductGridForActiveMobileFilters = () => {
    if (!dom.mobileActiveBar) {
      return;
    }
    const activeBarHeight = dom.mobileActiveBar.offsetHeight;
    const collectionGrid = document.querySelector('main.collection');

    collectionGrid.style.marginTop = (totalFilterCount > 0) ? `${activeBarHeight + 20}px` : '0px';
  }

  const setDefaultSort = () => {
    const currentSortSpan = document.querySelector('[data-current-sort]');
    const currentDefaultSort = currentSortSpan.getAttribute('data-current-sort') // default sort

    currentParams['sort_by'] = currentDefaultSort;
  }

  const setCurrentSortText = () => {
    let currentSort = currentParams['sort_by'];
    // https://gist.github.com/carolineschnapp/11352987#file-gistfile1-html
    if(window.location.search) {
      const keyValueString = window.location.search.substr(1).split('&');
      for(let i = 0; i < keyValueString.length; i++) {
        const keyValuePair = keyValueString[i].split('=');
        if(keyValuePair.length > 1) {
          currentParams[decodeURIComponent(keyValuePair[0])] = decodeURIComponent(keyValuePair[1]);
        }
      }
      currentSort = currentParams['sort_by'];
    }
    
    // set sort menu text
    const sortSpans = Array.from(document.querySelectorAll('[data-current-sort]'));
    sortSpans.forEach(span => span.textContent = SORT_VALUES[currentSort])

    // remove duplicated option
    const sortOptions = Array.from(document.querySelectorAll('[data-sort-value]'));
    sortOptions.forEach(option => {
      if(option.getAttribute('data-sort-value') === currentSort) option.remove();
    });
  }

  const updateFilterParams = () => {
    const params = new URLSearchParams();
    if (currentParams['sort_by']) {
      params.set('sort_by', currentParams['sort_by']);
    }
    Array.from(document.querySelectorAll('[data-filter-form] input:checked')).forEach(input => {
      const classValue = input.value.slice(1); // strip leading '.'
      const dash = classValue.indexOf('-');
      params.append(`filter.${classValue.slice(0, dash)}`, classValue.slice(dash + 1));
    });
    const queryString = params.toString();
    history.replaceState(null, '', queryString ? `?${queryString}` : window.location.pathname);
  }

  const applyFiltersFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    let hasFilters = false;

    dom.filterTypes.forEach(type => {
      const values = params.getAll(`filter.${type}`).map(val => `.${type}-${val}`);
      if (!values.length) return;

      // setFilterGroupSelectors updates MixItUp's internal group state and auto-checks
      // the corresponding inputs via updateUi — no event dispatch needed.
      mixer.setFilterGroupSelectors(type, values);

      // Add 'selected' to the filter labels — MixItUp handles input.checked but not our custom class.
      values.forEach(selector => {
        const input = document.querySelector(`[data-filter-form] input[value="${selector}"]`);
        if (input && input.hasAttribute('data-filter-input')) {
          input.parentElement.classList.add('selected');
        }
      });

      hasFilters = true;
    });

    if (hasFilters) {
      isInitialLoad = true;
      mixer.parseFilterGroups();
    }
  }

  const bindUiActions = () => {

    let resizeTimer;
    window.addEventListener('resize', (event) => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        setStickyFilters();
      }, 250);
    });

    window.addEventListener('scroll', throttle(adjustMobileSafariElements, 150));

    // click listener
    document.addEventListener('click', event => {
      const el = event.target;

      // OPEN MOBILE FILTERS
      if(el.matches('[data-open-mobile-filters]') 
        || (el.parentElement && el.parentElement.matches('[data-open-mobile-filters]'))) {
        openMobileFilters();
      }

      // CLOSE MOBILE FILTERS
      if(el.matches('[data-apply-mobile-filters]') || el.matches('[data-close-mobile-filters]')) {
        closeMobileFilters();
      }

      // OPEN FILTER DROPDOWNS
      if(el.matches('.filter-group__title, .filter-group__title span')) {
        const optionsList = el.nextElementSibling;
        toggleClass(el, 'active');
        toggleClass(optionsList, 'active');
        return;
      } 
      
      // CLOSE DROPDOWNS WHEN SOMETHING ELSE IS CLICKED
      if (!el.matches('.filter-group__options')
        && !el.matches('.filter-group__options *')
        && !el.matches('[data-open-sorting]')
        && !el.matches('[data-open-sorting] *')
        && !el.matches('[data-sort-options]')
        && !el.matches('[data-sort-options] *')) {
        closeAllDropdowns();
      }

      // CLEAR FILTERS (+ account for buttons with spans)
      if(el.matches('[clear-filters]') 
        || (el.parentElement && el.parentElement.matches('[clear-filters]'))) {
        clearFilters();
      }

      // OPEN SORT DROPDOWN (MOBILE)
      if(el.matches('.mobile-control-panel [data-open-sorting]')) {
        const optionsList = el.parentElement.nextElementSibling;
        toggleClass(el, 'active');
        toggleClass(optionsList, 'active');
        return;
      } else if (el.parentElement && el.parentElement.matches('.mobile-control-panel [data-open-sorting]')) {
        const optionsList = el.parentElement.parentElement.nextElementSibling;
        toggleClass(el.parentElement, 'active');
        toggleClass(optionsList, 'active');
        return;
      }

      // OPEN SORT DROPDOWN (DESKTOP)
      if(el.matches('.sort-bar [data-open-sorting]')) {
        const optionsList = el.nextElementSibling;
        toggleClass(el, 'active');
        toggleClass(optionsList, 'active');
        return;
      } else if (el.parentElement && el.parentElement.matches('.sort-bar [data-open-sorting]')) {
        const optionsList = el.parentElement.nextElementSibling;
        toggleClass(el, 'active');
        toggleClass(optionsList, 'active');
        return;
      }

      // GO TO SORTED COLLECTION URL
      if(el.matches('[data-sort-value]')) {
        const sortValue = el.getAttribute('data-sort-value');
        // update if different from current
        if(currentParams["sort_by"] !== sortValue) {
          currentParams["sort_by"] = sortValue;
          const params = new URLSearchParams();
          params.set('sort_by', sortValue);
          Array.from(document.querySelectorAll('[data-filter-form] input:checked')).forEach(input => {
            const classValue = input.value.slice(1);
            const dash = classValue.indexOf('-');
            params.append(`filter.${classValue.slice(0, dash)}`, classValue.slice(dash + 1));
          });
          location.search = `?${params.toString()}`;
        }
      }

      // SELECT COLOR FILTER (via artificial label)
      if(el.matches('[data-swatch-label] span')) {
        const swatchInput = el.parentElement.parentElement.querySelector('input:first-child');
        swatchInput.click();
      }

    });

    // ADD + REMOVE ACTIVE CLASSES ON NON-COLOR INPUTS
    const filterInputs = Array.from(dom.filterInputs);
    filterInputs.forEach(input => {
      input.addEventListener('change', (event) => {
        const label = event.target.parentElement;
        toggleClass(label, 'selected');
      });
    });
  }

  const initFilters = () => {
    const params = new URLSearchParams(window.location.search);
    const groupSelectors = dom.filterTypes
      .map(type => params.getAll(`filter.${type}`).map(val => `.${type}-${val}`))
      .filter(vals => vals.length > 0);

    const initialFilter = groupSelectors.length
      ? groupSelectors.reduce((combined, group) => combined.flatMap(a => group.map(b => a + b))).join(', ')
      : 'all';

    mixer = mixitup(dom.collectionGrid, { ...configMixer, load: { filter: initialFilter } });
  }

  const init = () => {
    setDefaultSort();
    setStickyFilters();
    setCurrentSortText();
    cacheDom();
    bindUiActions();
    initFilters();
    applyFiltersFromUrl();
  }

  Collection.init = init;
})((window.Collection = window.Collection || {}), jQuery);